import * as React from 'react';
import * as styles from './InteractiveElementsWrapper.css';
import { clsx } from 'clsx';

interface IInteractiveElementsWrapperProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children: React.ReactNode;
}

export const InteractiveElementsWrapper: React.FC<IInteractiveElementsWrapperProps> = ({
  children,
  className,
  ...restDivProps
}) => {
  return (
    <div className={clsx(styles['wrapper'], className)} {...restDivProps}>
      {children}
    </div>
  );
};
